import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'

import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { launchPunchTerminal } from 'store/actions/punchTerminal'
import { Button, Form, Select } from 'components/Forms'

function LaunchPunchTerminalModal() {
  const dispatch = useDispatch()
  const { tags } = useSelector(state => state.resources)
  const locations = tags.filter(tag => tag.type === 'locations').sort((a, b) => (a.name < b.name ? -1 : 1))

  return (
    <BaseModal hideButtons title={`manager.punch.LAUNCH_PUNCH_TERMINAL_MODAL`}>
      <Formik
        enableReinitialize={true}
        initialValues={{ location: locations[0] }}
        onSubmit={values => {
          const { location } = values
          dispatch(launchPunchTerminal(location._id))
          dispatch(closeModal())
        }}
      >
        {({ isSubmitting, dirty }) => (
          <Form className="mt-2" dirty={!!dirty && !isSubmitting}>
            <Select module="manager.punch" name="location" dontSort options={locations} />
            <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="punch.GO_TO" />
            <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} text="actions.CLOSE" />
          </Form>
        )}
      </Formik>
    </BaseModal>
  )
}

export default LaunchPunchTerminalModal
